<template>
    
    <v-card class="pb-4 align-stretch" height="100%" :loading="loading">

      <v-card-title>
        <slot name="title"></slot>
      </v-card-title>

      <v-card-text v-if="!loading">
        <slot name="content"></slot>
      </v-card-text>

    </v-card>

</template>

<script>
  export default {
    
    props: {
      isLoading: {
        type: Array,
        default: ()=>([])
      },
    },

    computed: {
      loading() {
        return this.isLoading.includes(true); 
      }
    },

  }
</script>

<style lang="scss" scoped>

</style>
